module.exports = __webpack_public_path__ + "img/241.1cbbe390.png";